import { render, staticRenderFns } from "./DashboardBaseCard.vue?vue&type=template&id=53122e02&"
import script from "./DashboardBaseCard.vue?vue&type=script&lang=js&"
export * from "./DashboardBaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports